import React from 'react';
import { Pagination } from 'react-bootstrap';

const MobileEventPagination = ({ page, sizePerPage, totalSize, onPageChange }) => {
	if (!totalSize || totalSize <= sizePerPage) {
		return null;
	}

	const totalPages = Math.ceil(totalSize / sizePerPage);

	return (
		<Pagination className="mobile-pagination">
			<Pagination.First disabled={page <= 1} onClick={() => onPageChange(1, sizePerPage)} />
			<Pagination.Prev disabled={page <= 1} onClick={() => onPageChange(page - 1, sizePerPage)} />
			<Pagination.Item disabled>{page} / {totalPages}</Pagination.Item>
			<Pagination.Next disabled={page >= totalPages} onClick={() => onPageChange(page + 1, sizePerPage)} />
			<Pagination.Last disabled={page >= totalPages} onClick={() => onPageChange(totalPages, sizePerPage)} />
		</Pagination>
	);
};

export default MobileEventPagination;
